class MutationAlias {
  static encodeEntityId(entityId) {
    return `_${String(entityId.value).replace(/-/g, "_")}`;
  }
  static decodeEntityId(alias) {
    const stringId = `${alias.substring(1).replace(/_/g, "-")}`;
    const intId = parseInt(stringId);
    return intId.toString() === stringId ? intId : stringId;
  }
}
export {
  MutationAlias
};
//# sourceMappingURL=MutationAlias.js.map
